<template>
  <div class="SaleFillInfoViewContainer" v-if="detail.good">
    <nut-row class="shadow pd16 box colFlex mt16"
             v-if="detail?.good?.afterPaidInviteQrCodeImage||detail?.sku?.afterPaidInviteQrCodeImage">
      <span>添加二维码</span>
      <img :src="detail.sku.afterPaidInviteQrCodeImage"
           v-if="detail?.sku?.afterPaidInviteQrCodeImage"
           class="wd100 mt16"/>
      <img :src="detail.good.afterPaidInviteQrCodeImage" v-else
           class="wd100 mt16"/>
    </nut-row>
    <nut-row class="shadow pd16 box colFlex">
      <nut-row class="colFlex ft14" v-if="detail.good.alwaysNeedName">
        <span>孩子姓名：</span>
        <input class="iceInput " :disabled="filled" placeholder="可以昵称" v-model="detail.contactName"/>
      </nut-row>
      <nut-row class="colFlex mt12 ft14" v-if="detail.good.alwaysNeedPhone||detail.sku.xuepaiCourseId!=null||detail.sku.xuepaiPlanId!=null">
        <span>开课手机号：</span>
        <input class="iceInput" placeholder="此项必填" :disabled="filled" v-model="detail.contactPhone"/>
      </nut-row>
      <nut-row class="colFlex mt12 ft14" v-if="detail.sku.expressGood||detail.good.alwaysNeedAddress">
        <span>邮寄地址：</span>
        <textarea class="iceInput" placeholder="地址、收货人、以及收货人电话" :disabled="filled" v-model="detail.contactAddress"/>
      </nut-row>
      <template v-for="(f,fi) in detail.good.paidForms" :key="`form_${fi}`">
        <nut-row class="colFlex mt12">
          <span>{{ f }}：</span>
          <template v-if="filled">
            <input class="iceInput" disabled v-model="detail.extraPaidInfos[f]"/>
          </template>
          <template v-else>
            <input class="iceInput" placeholder="请输入" v-model="detail[f]"/>
          </template>
        </nut-row>
      </template>
      <nut-row class="lightText ft10 mt10" v-if="!filled">
        <span>信息不可修改，提交前请仔细核对</span>
      </nut-row>
      <nut-row class="bothCenter mt24" v-if="!filled">
        <button class="submitBtn wft ft16 vpd8 brd8" @click="submit">提交</button>
      </nut-row>
    </nut-row>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "SaleFillInfoView",
  data() {
    return {
      orderId: this.$route.params.orderId,
      detail: {},
      filled: false,
    }
  },
  methods: {
    submit() {
      api.updateSaleOrderInfo(this.detail)
          .then(() => {
            this.$router.replace('/sale/customer/order/list')
          })
    },
    init() {
      api.getSaleOrder(this.orderId)
          .then(ret => {
            this.detail = ret;
            // this.filled = ret.contactPhone != null;
            this.filled = true;
          })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SaleFillInfoViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;


  .submitBtn {
    border: none;
    background: #E76A2C;
    width: 240px;
  }

  .iceInput {
    background: #F4F4F4;
    padding: 4px;
    width: 95%;
    border: #dedede 1px solid;
    margin-top: 10px;
  }
  .iceInput::placeholder{
    color: lightgray;
  }
  .iceInput:focus{
    outline: none;
  }
}
</style>